import type { FaireProductEntity } from "../../entity_types/product";

export const p_ccekpea5ha: FaireProductEntity = {
  token: "p_ccekpea5ha",
  type: "product",
  name: "Ceramic Nativity Ornament",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/eefee6d863dfa19315e00108cc59ba9cace7ccc9988474ef5f6212592163eb8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3f353e2ae76b96926985081fabe8b19c89f6cda6db432ef053aff9f33c64707.jpeg",
    "https://cdn.faire.com/fastly/b44122f637445e218f95a2074b518669a28ed7f092d5fb57b446f5a667bde357.jpeg",
    "https://cdn.faire.com/fastly/925cc602a704548ae5d30787d24b08d63538617bc211ba8e64023a30891032d9.jpeg"
  ],
  priceDollars: 9,
  description: "A porcelain ornament from our Christmas Collection displaying a sculpted nativity scene with painted details and metallic gold accents. Our Ceramic Nativity ornament is ready to hang for display via the attached hanger. A nativity themed Christmas home accent perfect for seasonal display.",
  tags: [],
  msrpDollars: 17.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:30.162Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
